import * as ActionTypes from "../actions/ActionTypes";
import userState from "./userState";

export default function userReducer(state=userState, action) {
    switch (action.type) {
        case ActionTypes.LOGIN_USER:
            console.log("loginUser", action);
            if (action.userData.error) {
                return {
                    isAuthenticated: false,
                    ...action.userData
                }
            }
            else {
                return {
                    isAuthenticated: true,
                    ...action.userData
               }
            }

        case ActionTypes.SIGNUP_USER:
            console.log("signupUser", action);
            return {
                isAuthenticated: false,
                ...action.userData
            }

        case ActionTypes.LOGOUT_USER:
            console.log("logoutUser", action);
            return {
                isAuthenticated: false,
            }
    
        default:
            return state;
    }
}